<template>
  <div>
    <h2 class="section-title">Planos pensados para o ritmo da sua clínica</h2>
    <p class="section-subtitle">
      A evolução acontece na prática: o sistema acompanha seu crescimento operacional e sua
      necessidade de controle.
    </p>

    <div class="plans">
      <div class="plan">
        <div class="plan-top">
          <div class="plan-badge-alt">Clínicas pequenas</div>
          <div class="plan-name">Plano Fit</div>
          <div class="plan-tag">Até 10 profissionais</div>
        </div>
        <div class="plan-body">
          <ul class="plan-list">
            <li>
              <span class="check" aria-hidden="true">✓</span>
              10 profissionais inclusos
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              Suporte prioritário
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              Agenda + recorrência
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              Evolução clínica
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              Portal do responsável
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              Controle de convênios
            </li>
          </ul>
        </div>
        <div class="plan-note">Feito para começar com organização e previsibilidade.</div>
      </div>

      <div class="plan plan-highlight">
        <div class="plan-top plan-top-highlight">
          <div class="plan-badge">Mais popular</div>
          <div class="plan-name plan-name-on-dark">Plano Plus</div>
            <div class="plan-tag plan-tag-on-dark">Até 20 Profissionais</div>
        </div>
        <div class="plan-body">
          <ul class="plan-list">
            <li>
              <span class="check" aria-hidden="true">✓</span>
              20 profissionais inclusos
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              Suporte VIP (resposta &lt; 2h)
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              Tudo do Fit
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              Multi-clínica (2 unidades)
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              Relatórios de produtividade
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              Onboarding dedicado
            </li>
          </ul>
        </div>
        <div class="plan-note">Mais controle para crescer com consistência.</div>
      </div>

      <div class="plan">
        <div class="plan-top">
          <div class="plan-badge-alt">Centros e redes</div>
          <div class="plan-name">Plano Premium</div>
          <div class="plan-tag">Até 30 Profissionais</div>
        </div>
        <div class="plan-body">
          <ul class="plan-list">
            <li>
              <span class="check" aria-hidden="true">✓</span>
              30 Profissionais inclusos
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              Suporte VIP + gerente de conta
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              Tudo do Plus
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              Multi-clínica ilimitada
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              API de integração
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              Dashboard BI consolidado
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              SLA contratual garantido
            </li>
          </ul>
        </div>
        <div class="plan-note">Para redes que precisam padronizar e escalar.</div>
      </div>

      <div class="plan">
        <div class="plan-top">
          <div class="plan-badge-alt plan-badge-alt-warm">Redes / franquias</div>
          <div class="plan-name">Plano Enterprise</div>
          <div class="plan-tag">Sob consulta</div>
        </div>
        <div class="plan-body">
          <ul class="plan-list">
            <li>
              <span class="check" aria-hidden="true">✓</span>
              5+ unidades
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              Agente de IA para análise de dados
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              Implantação + CS dedicado
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              Tudo do Premium
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              Treinamento em equipe
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              Relatório consolidado de rede
            </li>
            <li>
              <span class="check" aria-hidden="true">✓</span>
              Desconto por volume
            </li>
          </ul>
        </div>
        <div class="plan-note">Sob medida para operações maiores.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default { name: 'PlansSection' }
</script>

<style scoped>
.plans {
  margin-top: 22px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.plan {
  border: 1px solid rgba(148, 163, 184, 0.45);
  border-radius: 16px;
  background: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 420px;
}

.plan-top {
  padding: 16px 16px 14px;
  background: #fff;
}

.plan-badge-alt {
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  background: rgba(77, 186, 135, 0.08);
  border: 1px solid rgba(77, 186, 135, 0.18);
  color: rgba(15, 23, 42, 0.9);
  font-weight: 950;
  font-size: 12px;
}

.plan-badge-alt-warm {
  background: rgba(245, 158, 11, 0.10);
  border-color: rgba(245, 158, 11, 0.25);
  color: rgba(124, 45, 18, 0.95);
}

.plan-name {
  font-weight: 1000;
  font-size: 18px;
  color: var(--easy-dark);
}

.plan-tag {
  margin-top: 6px;
  color: var(--easy-muted);
  font-weight: 900;
  font-size: 13px;
}

.plan-body {
  padding: 6px 16px 0;
}

.plan-list {
  list-style: none;
  padding: 0;
  margin: 10px 0 0;
  display: grid;
  gap: 12px;
  line-height: 1.4;
  font-size: 14px;
  color: var(--easy-dark);
}

.plan-list li {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.check {
  width: 20px;
  height: 20px;
  border-radius: 999px;
  background: rgba(77, 186, 135, 0.18);
  color: var(--easy-green);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 1000;
  flex: 0 0 auto;
  margin-top: 1px;
}

.plan-note {
  margin-top: auto;
  padding: 14px 16px 18px;
  color: rgba(100, 116, 139, 0.95);
  font-weight: 900;
  font-size: 13px;
  line-height: 1.45;
}

.plan-highlight {
  border-color: rgba(14, 124, 111, 0.65);
  box-shadow: 0 18px 40px rgba(13, 148, 136, 0.14);
  transform: translateY(-6px);
}

.plan-top-highlight {
  background: linear-gradient(180deg, #0E7C6F 0%, #0A6A5E 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.plan-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  padding: 0 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  font-weight: 1000;
  font-size: 13px;
}

.plan-name-on-dark {
  color: #fff;
}

.plan-tag-on-dark {
  color: rgba(255, 255, 255, 0.9);
}

.plan-highlight .plan-note {
  border-top: 1px solid rgba(14, 124, 111, 0.22);
}

@media (max-width: 1100px) {
  .plans {
    grid-template-columns: repeat(2, 1fr);
  }
  .plan-highlight {
    transform: none;
  }
}

@media (max-width: 560px) {
  .plans {
    grid-template-columns: 1fr;
  }
}
</style>
